export default __webpack_public_path__ + "static/443-727c22d6f6fa79978b54ff86800e2a5f.gif";